export class Login {
  public UserName: string = '';
  public Password: string = '';
  public FCMToken: string = '';
  public DeviceType: number = 1;
  public IsReturnClaims: boolean = true;

  constructor() { }
}
